import { getCsrfToken } from '../../utils/api_helper'

function initApplicationInvitation() {
  const resendButton = document.querySelector<HTMLButtonElement>(
    '#resend_invitation_button',
  )
  if (resendButton) {
    const el = document.querySelector<HTMLElement>('#application-id')
    const applicationId = el?.dataset.applicationId
    resendButton.addEventListener('click', async () => {
      resendButton.setAttribute('disabled', '')
      const csrfToken = getCsrfToken()
      await fetch(
        `/partner/applications/${applicationId}/resend_offer_invitation`,
        {
          method: 'POST',
          headers: {
            'x-csrftoken': csrfToken,
          },
        },
      )
      window.location.reload()
    })
  }
}

export { initApplicationInvitation }
